"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CardLostMissingLined = function CardLostMissingLined(_ref) {
  var className = _ref.className,
      style = _ref.style,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "style"]);

  var styleProp = Object.assign({
    verticalAlign: 'middle'
  }, style);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className),
    viewBox: "0 0 24 24",
    style: styleProp
  }, otherProps), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9 8a1 1 0 111 1 1 1 0 01-1-1zm5 1a1 1 0 10-1-1 1 1 0 001 1zm.042 4H21v3a1 1 0 01-1 1h-.514c-.412 2.16-1.061 3.682-1.952 4.447a2.056 2.056 0 01-1.348.553 1.508 1.508 0 01-.243-.019c-.931-.147-1.089-.957-1.183-1.441-.092-.469-.139-.548-.256-.575-.162-.035-.6.54-.773.756-.538.66-1.208 1.481-2.134 1.218a1.553 1.553 0 01-1.016-1.32c-.122-.494-.184-.6-.389-.643-.223-.043-.615.317-.947.644-.5.5-1.075 1.059-1.819.891a1.341 1.341 0 01-1.039-1.3c-.066-.412-.1-.56-.412-.669a1.572 1.572 0 00-.474.174 1.8 1.8 0 01-1.505.2c-.514-.223-1.309-.83-.867-2.387a3.654 3.654 0 01.69-1.274c.561-.755 1.258-1.681 1.258-5.755 0-.09.086-8.5 7.462-8.5C17.665 2 20 6.4 20 10.5c0 .176-.008.333-.01.505H20a1 1 0 011 1h-7.906a1.359 1.359 0 01.948.995zm4.449 4H13a1 1 0 01-1-1v-.495A7.268 7.268 0 019.5 16a.5.5 0 010-1 5.206 5.206 0 003.442-1.243c.2-.24.166-.389.157-.439-.073-.36-.221-.421-1.323-.548a12.706 12.706 0 01-3.459-.8.5.5 0 11.366-.93 11.79 11.79 0 003.208.741l.15.019A.987.987 0 0113 11h6c0-.17.006-.329.006-.505 0-3.61-2.023-7.5-6.466-7.5-6.378 0-6.466 7.19-6.467 7.5 0 4.413-.809 5.492-1.459 6.358a2.718 2.718 0 00-.528.946c-.269.946.12 1.115.306 1.2.153.067.426-.061.692-.185a1.6 1.6 0 011.225-.214 1.6 1.6 0 011.06 1.452c.067.42.093.441.276.483.24.056.6-.327.9-.628.487-.481 1.1-1.08 1.861-.907a1.563 1.563 0 011.138 1.377c.112.454.167.555.322.6.307.083.739-.456 1.091-.89.431-.53.914-1.124 1.536-1.124a1 1 0 01.233.028c.778.181.916.888 1.007 1.356.108.552.164.615.362.646a1 1 0 00.789-.307c.479-.408 1.149-1.386 1.607-3.686z",
    fill: "currentColor"
  })));
};

var _default = CardLostMissingLined;
exports["default"] = _default;